/**
 * Init slider featured.
 */

import 'slick-carousel';

const sliderFeatured = function() {
  const $slider = $('.js-slider-featured');
  let speed = parseInt($slider.data('speed') * 1000) || 3000;

  if( ! $slider.length ) {
    return;
  };
  
  $slider.slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 2,
    infinite: true,
    focusOnSelect: true,
    touchMove: true,
    centerMode: true,
    centerPadding: '0',
    autoplay: true,
    autoplaySpeed: speed,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          centerPadding: '150px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerPadding: '80px',
        }
      }
    ],
  });
};

sliderFeatured();
